import NoAccess from '../../partials/NoAccess';

const ENTERPRISE_ROUTE_PREFIX = '/api/v1/enterprise/';

// Every enterprise screen is gated on its permission before it fetches, so a "Request not allowed"
// from an enterprise route means the enterprise itself was deactivated.
export const isEnterpriseDeactivated = (error) =>
  error?.response?.status === 403 &&
  error.response.data?.message === 'Request not allowed' &&
  String(error.config?.url ?? '').startsWith(ENTERPRISE_ROUTE_PREFIX);

const EnterpriseDeactivated = () => (
  <NoAccess title="Account deactivated" message="This account is deactivated. Contact CashAfrica support." />
);

export default EnterpriseDeactivated;
